var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-y-auto styled-scrollbar",style:({ maxHeight: _vm.maxHeight, overflowX: 'hidden', height: '100%' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }